import type { ExpendTeamRow } from './types';

export const getExpendIncomeAmount = (expend: ExpendTeamRow | null | undefined): number =>
    Number(expend?.income_amount ?? expend?.incomeAmount ?? 0) || 0;

export const getExpendIncomeAmountRate = (expend: ExpendTeamRow | null | undefined): number =>
    Number(expend?.income_amount_rate ?? expend?.incomeAmountRate ?? 0) || 0;

export const getExpendIncomeStatus = (expend: ExpendTeamRow | null | undefined): number =>
    Number(expend?.income_status ?? expend?.incomeStatus ?? 0) || 0;

export const getExpendTeamId = (expend: ExpendTeamRow | null | undefined): number =>
    Number(expend?.team_id ?? expend?.teamId ?? 0) || 0;

export const getExpendTeamName = (expend: ExpendTeamRow | null | undefined): string =>
    String(expend?.team_name ?? expend?.teamName ?? '');
